const translations = {
    es: {
        "mode" : "Modo",
        "mode.description": "Modo de funcionamiento del GPS. Desactivado, Horas, Días",
        "mode.choices.0": "Desactivado",
        "mode.choices.1": "Horas",
        "mode.choices.2": "Días",
        "time": "Minutos",
        "time.description": "Minutos desde la media noche para realizar la medición. Entre 0 y 1439",
        "interval": "Intervalo",
        "interval.description": "Frecuencia para la repetición del mensaje (en horas o días según el valor del parámetro Modo).",
        // -
        "create.title": "Crear configuración de GPS",
        "edit.title": "Editar configuración de GPS",
    },
    en: {
        "mode" : "Mode",
        "mode.description": "Mode of operation of the GPS. Disabled, Hours, Days",
        "mode.choices.0": "Disabled",
        "mode.choices.1": "Hours",
        "mode.choices.2": "Days",
        "time": "Minutes",
        "time.description": "Minutes from midnight to perform the measurement. Between 0 and 1439",
        "interval": "Interval",
        "interval.description": "Frequency for the message repetition (in hours or days depending on the value of the Mode parameter).",
        // -
        "create.title": "Create GPS configuration",
        "edit.title": "Edit GPS configuration",
    },
};

export default translations;
